import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";

import App from "./App";

const normalizeEnvValue = (value) => String(value || "").trim().toLowerCase();

const looksLikeTestEnv = (value) => {
	const normalized = normalizeEnvValue(value);
	return /(^|[.:/_-])(test|staging|homolog|hml|qa|sandbox)([.:/_-]|$)/.test(normalized);
};

const shouldUseTestFavicon = () => {
	const explicit = normalizeEnvValue(
		process.env.REACT_APP_FAVICON_VARIANT ||
			process.env.REACT_APP_APP_ENV ||
			process.env.REACT_APP_ENV ||
			process.env.REACT_APP_STAGE ||
			process.env.REACT_APP_ENVIRONMENT
	);

	if (explicit) {
		return looksLikeTestEnv(explicit);
	}

	const runtimeVariant = normalizeEnvValue(window?.__FAVICON_VARIANT__);
	if (runtimeVariant) {
		return runtimeVariant === "test" || looksLikeTestEnv(runtimeVariant);
	}

	if (looksLikeTestEnv(process.env.REACT_APP_BACKEND_URL)) {
		return true;
	}

	return looksLikeTestEnv(window?.location?.hostname);
};

const setAppFavicon = () => {
	const publicUrl = String(process.env.PUBLIC_URL || "").replace(/\/$/, "");
	const useTestFavicon = shouldUseTestFavicon();
	const cacheQuery = useTestFavicon ? "v=4-test" : "v=2";
	const filename = useTestFavicon ? "favicon-test.ico" : "favicon.ico";
	const href = `${publicUrl}/${filename}?${cacheQuery}`;

	const links = document.querySelectorAll("link[rel~='icon']");
	links.forEach((link) => link.setAttribute("href", href));

	const manifestLink = document.querySelector("link[rel='manifest']");
	if (manifestLink) {
		const manifestFilename = useTestFavicon ? "manifest-test.json" : "manifest.json";
		manifestLink.setAttribute("href", `${publicUrl}/${manifestFilename}?${cacheQuery}`);
	}

	const appleTouchIconLink = document.querySelector("link[rel='apple-touch-icon']");
	if (appleTouchIconLink) {
		const appleFilename = useTestFavicon ? "apple-touch-icon-test.png" : "apple-touch-icon.png";
		appleTouchIconLink.setAttribute("href", `${publicUrl}/${appleFilename}?${cacheQuery}`);
	}

	const msTileImage = useTestFavicon ? "mstile-150x150-test.jpg" : "mstile-150x150.jpg";
	let msMeta = document.querySelector("meta[name='msapplication-TileImage']");
	if (!msMeta) {
		msMeta = document.createElement("meta");
		msMeta.setAttribute("name", "msapplication-TileImage");
		document.head.appendChild(msMeta);
	}
	msMeta.setAttribute("content", `${publicUrl}/${msTileImage}?${cacheQuery}`);
};

setAppFavicon();

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root")
);

// ReactDOM.render(
// 	<React.StrictMode>
// 		<CssBaseline>
// 			<App />
// 		</CssBaseline>,
//   </React.StrictMode>

// 	document.getElementById("root")
// );
